module.exports = __webpack_public_path__ + "static/media/5_Katty_P@3x.65d4d632.jpg";